module.exports = __webpack_public_path__ + "static/media/iris_editor_metric_detail.f30523f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iris_editor_metric_detail.png
// module id = 390
// module chunks = 17